class MainSearch extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      resultsGrid: '[js-search-results-grid]',
      searchForm: '[js-search-form]',
      searchInput: '#Search-In-Template',
      searchTerms: '[js-search-terms]',
      noResults: '[js-search-no-results]',
      resultsContainer: '[js-search-results-container]',
      filters: '[js-searchspring-filters]',
      sort: '[js-searchspring-sort]',
      pagination: '[js-search-pagination]',
    }
  }

  connectedCallback() {
    this.collectionMode == this.dataset.collectionMode || 'regular';
    this.collectionHandle = this.dataset.collectionHandle;
    this.resultsGrid = this.querySelector(this._selectors.resultsGrid);
    this.form = this.querySelector(this._selectors.searchForm);
    this.input = this.querySelector(this._selectors.searchInput);
    this.noResults = this.querySelector(this._selectors.noResults);
    this.resultsContainer = this.querySelector(this._selectors.resultsContainer);
    this.sort = this.querySelector(this._selectors.sort);
    this.pagination = this.querySelector(this._selectors.pagination);
    this.searchTerms = this.querySelector(this._selectors.searchTerms);
    this.filtersContainer = document.querySelector(this._selectors.filters);
    this.sortContainer = document.querySelector(this._selectors.sort);

    this.siteId = 'zcq50k';
    this.query = new URLSearchParams(window.location.search).get("query");
    this.input.value = this.query;

    this.storeData = {
      filters: '',
      sort: '',
      currentPage: 1,
      gridView: '',
      view: this.dataset.collectionMode === 'expanded' ? 'expanded' : '',
    }

    this.openedFiltersAccordionTabs = [];

    this.iconPlus = `<svg class="icon icon-plus" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <title>Plus</title>
                      <path d="M7 0V14" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M14 7L-7.15256e-07 7" stroke="currentColor" stroke-width="1.5"/>
                    </svg>`;
    this.iconMinus = `<svg class="icon icon-minus" viewBox="0 0 13 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Minus</title>
                        <path d="M14 1L-7.15256e-07 0.999999" stroke="currentColor" stroke-width="1.5"/>
                      </svg>`;
    this.iconHeart = `<svg class="icon icon--full-color icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Favorite</title>
                        <path d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z" stroke="currentColor" stroke-width="1.5"/>
                      </svg>`;
    this.iconCarat = `<svg class="icon  icon--full-color icon-carat" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Carat</title>
                        <path d="M1 9.12402L6.85117 4.24805L12.7023 9.12402" stroke="currentColor"/>
                      </svg>`;

    this.triggered = false;
    this._retainHistory();
    this._clearFilterSort();
    this._setListeners();
  }

  _setListeners() {
    window.addEventListener('scrollend', this._handleScrollEnd);
    window.addEventListener('scroll', this._handleScroll);
    this.form.addEventListener("submit", this._onSubmit);
  }

  _retainHistory() {
    if (!history.state) {
      return;
    }

    if (history.state.filters) {
      this.storeData.filters = history.state.filters;
    }

    if (history.state.sort) {
      this.storeData.sort = history.state.sort;
    }

    if (history.state.currentPage) {
      this.storeData.currentPage = history.state.currentPage;
    }
  }

  _changeHistory(url = false, clear = false) {
    if(this.storeData.view === 'expanded') {
      return
    }

    let state = {};
    if (history.state) {
      state = history.state;
    }

    state.filters = this.storeData.filters;
    state.sort = this.storeData.sort;
    state.currentPage = this.storeData.currentPage;
    state.gridView = this.storeData.gridView;

    if (url) {
      let searchParams = `${this.query ? '' : '?'}${this.storeData.filters}${this.storeData.sort}&page=${this.storeData.currentPage}`;
      if (clear) {
        searchParams = `${this.storeData.currentPage != 1 ? `${this.query ? '' : '?'}&page=${this.storeData.currentPage}` : ''}`;
      }
      const newPath = `${window.location.pathname}${this.query ? `?query=${this.query}` : ''}${searchParams}`;
      history.pushState(state, '', newPath);
    } else {
      history.pushState(state, '');
    }
  }

  _paginationComponent(pagination) {
    if (pagination.nextPage != 0) {
      return  `<button class="template-search__view-more-button btn block mx-auto mt-40 desktop:mt-56 max-w-max" js-search-view-more-btn>
                See More (${pagination.totalResults - pagination.end})
              </button>`
    } else {
      return '';
    }
  }

  _loadNextPage() {
    const viewMoreBtn = this.pagination.querySelector('[js-search-view-more-btn]');
    if (viewMoreBtn) {
      viewMoreBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.storeData.currentPage++;
        this._changeHistory(true, false);
        this._fetchSearchAPI(true);
      });
    }
  }

  getCookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts && parts.length === 2) {
			return parts.pop().split(';').shift();
		} else {
			return ''
		}
	};

  callSearchSpringPreflight = async () => {
		const personalizedParams = this.getPersonalizationParams();
		const url = `https://${this.siteId}.a.searchspring.io/api/personalization/preflightCache?shopper=${personalizedParams.shopper}&cart=${personalizedParams.cart}&lastViewed=${personalizedParams.lastViewed}`;
		const options = {method: 'GET'};
		const response = await fetch(url, options)
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
	}

	getTrackingParams = () => {
		return {
			userId: this.getCookie('ssUserId'),
			sessionId: this.getCookie('ssSessionIdNamespace'),
			pageLoadId: this.getCookie('pageLoadId'),
			domain: window.location.href
		};
	};

	getPersonalizationParams = () => {
		return {
			shopper: this.getCookie('ssUserId'),
			cart: this.getCookie('ssCartProducts'),
			lastViewed: this.getCookie('ssViewedProducts')
		};
	};

  async _renderProductCards(res, productCardsMarkup, nextPage) {
    if (res.merchandising.redirect !== '') {
      window.location.href = res.merchandising.redirect;
      return false;
    }

    this.triggered = true;
    if (res.pagination.totalResults > 0) {
      if (!nextPage) {
        this.resultsGrid.innerHTML = '';
      }

      this.noResults.classList.add('hidden');
      this.resultsContainer.classList.remove('hidden');
      this.resultsGrid.insertAdjacentHTML("beforeend", productCardsMarkup);

      const paginationMarkup = this._paginationComponent(res.pagination);
      this.pagination.innerHTML = paginationMarkup;

      const filtersMarkup = this._filtersComponent(res);

      if(window.rfd && window.rfd.collectionPageMobileCarouselReinit && this.collectionMode !== 'expanded') {
        window.rfd.collectionPageMobileCarouselReinit();
      }

      if (this.collectionHandle) {
        if (!!this.filtersContainer) {
          this.filtersContainer.innerHTML = filtersMarkup;
          this._updateFiltersAccordion();
          this._handleFiltersChange();

          const sortMarkup = this._sortComponent(res.sorting);
          this.sortContainer.innerHTML = sortMarkup;
          this._handleSortChange();
        }
      }
      this.triggered = false;
      document.body.classList.add('collection-loaded');
    } else {
      this.noResults.querySelector('[js-search-query]').textContent = `"${this.query}"`;
      this.noResults.classList.remove('hidden');
      this.resultsContainer.classList.add('hidden');
    }
  }

  async _fetchSearchAPI(nextPage = false) {
    const isExpandedView = this.dataset.collectionMode === 'expanded'
    const productsPerPage = isExpandedView ? 54: 36;
    const productsNum = parseInt(this.storeData.currentPage) * productsPerPage;

    const personalizedParams = this.getPersonalizationParams();
    const trackingParams = this.getTrackingParams();

    const baseParams = new URLSearchParams({
      siteId: this.siteId,
      ...trackingParams,
      ...personalizedParams,
    }).toString();

    const fetchUrl = `https://${this.siteId}.a.searchspring.io/api/search/search.json?${baseParams}&resultsFormat=json${this.query ? `&q=${this.query}`: ''}&redirectResponse=minimal&page=${nextPage ? this.storeData.currentPage : 1}&resultsPerPage=${nextPage ? productsPerPage : productsNum}${this.storeData.filters}${this.collectionHandle ? `&bgfilter.collection_handle=${this.collectionHandle}` : ''}&bgfilter.ss_is_published=1&is_published=yes${this.storeData.sort}`;
    const options = { method: 'GET', headers: { accept: 'application/json' } };

    // Call SearchSpring Preflight
    await this.callSearchSpringPreflight().then().catch((error) => {
      console.error('Preflight Cache Error:', error);
    });

    const searchResponse = await Promise.all([
      fetch(fetchUrl, options),
    ]).then(responses => {
      return Promise.all(responses.map(function (response) {
        return response.json();
      }));
    }).then(async response => {
      let productCardsMarkup = '<ul class="template-search__results-grid w-full list-none grid grid-cols-2 gap-x-16 desktop:grid-cols-4 gap-y-24 desktop:gap-y-40 pl-0" role="list" js-search-results-grid>';

      if(!isExpandedView) {
        if (response[0].results && response[0].results.length > 0) {
          let productCardArray = new Array;
          var productCardFetches = [];
          for (const product of response[0].results) {
            // productCardArray.push(`${product.handle}, ${product.price}`);
            productCardFetches.push(
              fetch(`/products/${product.handle}/?view=product-card`)
                .then(response => response.text())
                .then((text) => {
                  const html = text;
                  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                  if (parsedHTML.querySelector('[js-product-card-copy]') != null) {
                    parsedHTML.querySelector('.products__listing.js-block').setAttribute('data-index', response[0].results.indexOf(product) + 1);
                    const productCardCopy = parsedHTML.querySelector('[js-product-card-copy]').innerHTML;
                    productCardArray.push(productCardCopy);
                  }
                })
            )
          }

          await Promise.all(productCardFetches).then(function() {
            for (const productCard of productCardArray) {
              const productCardContent = new DOMParser().parseFromString(productCard, 'text/html');
              const productCardWrapper = `
                <li
                  class="template-search__grid-item"
                  style="--order-index: ${productCardContent.querySelector('.products__listing.js-block').getAttribute('data-index')};"
                >
                  ${productCard}
                </li>
              `;
              productCardsMarkup = `${productCardsMarkup}${productCardWrapper}`
            }
          });
        }
      } else {
        response[0].results.map(result => {
          const altImage = result.images && result.images[1]
          const productVideo = false // result.mfield_custom_product_card_video || TODO: Searcspring API does not return video URL, only the UID of the video
          const showProductVideoAsPrimaryAsset = result.mfield_custom_show_product_card_video_as_primary_asset

          productCardsMarkup += `
          <li
            class="template-search__grid-item"
          >
            <a href="${result.url}" aria-label="View ${result.name}">
              ${showProductVideoAsPrimaryAsset && productVideo ?
                `
                  <video
                    src="${productVideo}"
                    alt="${result.name}"
                    loop
                    autoplay
                    muted
                    playsinline
                  >
                  </video>
                ` :
                `
                  <img
                    src="${result.imageUrl}"
                    alt="${result.name}"
                  />
                `
              }
            </a>
          </li>
        `;

        })

      }

      productCardsMarkup = `${productCardsMarkup}</ul>`;

      if (!!response[0].pagination.totalResults) {
        this.searchTerms.innerHTML = `
          <div class="heading__inner">
            <h1 class="h4 heading__inner-search">${response[0].pagination.totalResults} search results for "${this.query}"</h1>
          </div>
        `;
      }

      return [response[0], productCardsMarkup];
    }).catch(function (error) {
      console.log(error);
    });

    if (searchResponse[1].length > 0) {
      this._renderProductCards(searchResponse[0], searchResponse[1], nextPage);
      this._loadNextPage();
    }
  }

  _filtersComponent(res) {
    const facets = res.facets;
    let filtersMarkup = '';
    facets.forEach((facet, index) => {
      const activeValuesPerFacet = facet.values.filter(value => value.active);
      const numRows = Math.ceil(facet.values.length / 2.0);
      let facetValues= '';

      facet.values.forEach((value, i) => {
        const valueId = `FilterSort-${facet.field}-${i}`;
        facetValues = `
          ${facetValues}
          <li class="filter-sort__value">
            <div class="filter-value">
              <input type="checkbox"
                name="${value.label}"
                value="${value.type == 'range' ? `&filter.${facet.field}.low=${value.low}&filter.${facet.field}.high=${value.high}` : `&filter.${facet.field}=${value.value}`}"
                id="${valueId}"
                class="filter-value__input"
                ${value.active ? 'checked' : ''}
                ${value.count == 0 && value.active == false ? 'disabled' : ''}
                js-searchspring-filter-input
              >
              <label for="${valueId}" class="filter-value__label ${value.count == 0 && value.active == false ? 'disabled opacity-30' : ''}">
                <span class="break-words">${facet.multiple == 'single' ? `${value.label == 'Yes' ? 'YES' : 'NO' }` : `${value.label}`}</span>
                <span class="filter-value__label-count font-coolvetica font-400 hidden"> (${value.count})</span>
              </label>
            </div>
          </li>
        `;
      });
      filtersMarkup = `
        ${filtersMarkup}
        <div class="filter-sort accordion-item border-b border-black ${facet.label == 'Collection' ? 'hidden' : ''}" data-index="${index}" js-accordion-item>
          <button class="filter-sort__label accordion-header" aria-expanded="false" aria-controls="${facet.field}-master-filter" type="button" js-accordion-header>
            <div class="label__wrapper">
              <sapn class="filter-sort__label-text flex-1">${facet.label}</sapn>
            </div>
            <span class="filter-sort__label-icon">${this.iconPlus}${this.iconMinus}</span>
          </button>
          <div id="${facet.field}-master-filter" class="filter-sort__values-container accordion-content" aria-hidden="true" js-accordion-content>
            <ul class="filter-sort__values pb-16 pl-40 grid grid-cols-2 gap-4" role="list" style="--num-rows: ${numRows};">${facetValues}</ul>
          </div>
        </div>
      `;
    });

    return `
      <form class="searchspring-filters__form">
        <div class="filter-sort__filters-container">
          <s-accordion class="block border-t border-black" data-manual-collapse="false" js-accordion>${filtersMarkup}</s-accordion>
        </div>
        <div class="filter-sort__footer">
          <button class="btn btn--clear filters__clear-btn js-clear-filters-btn">
            Clear Filters
          </button>
        </div>
      </form>
    `;

  }

  _clearFilterSort() {
    this.storeData.filterSort = '';
    this.storeData.currentPage = 1;
    this._changeHistory(true, true);
    this._fetchSearchAPI();
  }

  _handleSortChange() {
    this.sortContainer.querySelectorAll('a').forEach(sortOption => {
      sortOption.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.storeData.sort = evt.currentTarget.dataset.value;
        this._changeHistory(true, false);
        this._fetchSearchAPI();
      })
    });
  }

  _handleFiltersChange() {
    const filterForm = this.filtersContainer.querySelector('form');
    filterForm.addEventListener('input', (evt) => {
      evt.preventDefault();
      this.openedFiltersAccordionTabs = filterForm.querySelectorAll('[js-accordion-header][aria-expanded="true"]');
      const checkedInputs = filterForm.querySelectorAll('[js-searchspring-filter-input]:checked');
      let activeValues = '';
      checkedInputs.forEach((input) => {
        activeValues = `${activeValues}${input.value}`;
      });
      this.storeData.filters = activeValues;
      this._changeHistory(true, false);
      this._fetchSearchAPI();
    });
  }

  _updateFiltersAccordion() {
    this.openedFiltersAccordionTabs.forEach((tab) => {
      const openedTab = this.filtersContainer.querySelector(`[js-accordion-header][aria-controls=${tab.getAttribute('aria-controls')}]`);
      if (openedTab) {
        openedTab.setAttribute('aria-expanded', true);
        openedTab.nextElementSibling.setAttribute('aria-hidden', false);
      }
    });
  }

  _sortComponent(sort) {
    return `
      <li class="filter-group__item" data-href="?sort_by=created-descending">
        <a
          data-href="?sort_by=created-descending"
          data-value="&amp;sort.ss_days_since_published=asc"
          data-filter-sort
          data-ajax-ctrl
        >
        Newest
        </a>
      </li>

      <li class="filter-group__item" data-href="?sort_by=price-ascending">
        <a
          data-href="?sort_by=price-ascending"
          data-value="&amp;sort.ss_price=asc"
          data-filter-sort
          data-ajax-ctrl
        >
        Price (Lowest)
        </a>
      </li>
      <li class="filter-group__item" data-href="?sort_by=price-descending">
        <a
          data-href="?sort_by=price-descending"
          data-value="&amp;sort.ss_price=desc"
          data-filter-sort
          data-ajax-ctrl
        >
        Price (Highest)
        </a>
      </li>
      <li class="filter-group__item" data-href="?sort_by=title-ascending">
        <a
          data-href="?sort_by=title-ascending"
          data-value="&amp;sort.title=asc"
          data-filter-sort
          data-ajax-ctrl
        >
        Name (A-Z)
        </a>
      </li>
      <li class="filter-group__item" data-href="?sort_by=title-descending">
        <a
          data-href="?sort_by=title-descending"
          data-value="&amp;sort.title=desc"
          data-filter-sort
          data-ajax-ctrl
        >
        Name (Z-A)
        </a>
      </li>
    `;
  }

  _onSubmit = (evt) => {
    evt.preventDefault();
  }

  _handleScrollEnd = (evt) => {
    evt.preventDefault();

    if (this.resultsGrid.scrollHeight - 1400 < window.scrollY) {
      this.pagination?.querySelector('button')?.click();
    }
  }

  _handleScroll = (evt) => {
    evt.stopPropagation()
    const element = this.resultsGrid;

    const scrollPosition = window.scrollY
    const nearBottom = scrollPosition / element.scrollHeight >= 0.7 // within 30% of the bottom

    if (nearBottom && !this.triggered) {
      this.triggered = true
      this.pagination?.querySelector('button')?.click();
    }
  }
}

customElements.define("main-search", MainSearch);
